module.exports = __webpack_public_path__ + "static/media/004-ER18_1kNdzN56MWsD2sXJCLg5Lj9JRvw2L4TiO.f2605098.bin";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbs/004-ER18_1kNdzN56MWsD2sXJCLg5Lj9JRvw2L4TiO
// module id = 679
// module chunks = 0